"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./tooltip.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// eslint-disable-line
var Tooltip = function Tooltip(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "Tooltip ".concat(props.position)
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "tooltipContent"
  }, props.infoText), /*#__PURE__*/_react["default"].createElement("span", {
    className: "anchor ".concat(props.className)
  }, props.children));
};

Tooltip.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  infoText: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node, _propTypes["default"].string.isRequired]).isRequired,
  className: _propTypes["default"].string,
  position: _propTypes["default"].oneOf(['top', 'right', 'bottom', 'left'])
};
Tooltip.defaultProps = {
  className: '',
  position: 'right'
};
var _default = Tooltip;
exports["default"] = _default;